<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";

  // Client-side redirect helper for renamed routes (replaces history entry).
  export let to: string;

  onMount(() => navigate(to, { replace: true }));
</script>
